<template xmlns:>
  <div class="page-header-index-wide transparent-area-appear">
    <a-row :span="24" >
      <a-card :loading="loading" :bordered="false" >
        <a-row :gutter="[15, 15]" class="row-box">
          <!-- <a-col :xl="4" :lg="7" :md="9" :sm="24">
            <j-dict-select-tag
              placeholder="请选择年级"
              v-model="queryParam.gradeId"
              dictCode="school_grade,grade_name,id,0=delete_flag order by sort_order"
              allowClear
            />
          </a-col> -->
          <a-col :xl="4" :lg="6" :md="9" :sm="24">
            <j-dict-select-tag
              placeholder="请选择班级"
              v-model="queryParam.classId"
              :dictCode="'school_class,name,id,grade_id=' + (!queryParam.gradeId ? -1 : queryParam.gradeId)"
              :async="true"
            />
          </a-col>
          <a-col :xl="4" :lg="6" :md="9" :sm="24">
            <a-range-picker :value="rangeDate" @change="onRangeChange" style="width: 100%;"/>
          </a-col>

          <a-col :span="2" v-for="(item, index) in searchItem" :key="item" class="tag-col">
            <div
              class="tag-item"
              :style="{borderLeft: `4px solid ${searchItemColor[index]}`}"
            >
              <span class="tag-name">{{ item }}</span>
              <!-- <span class="delete-icon" @click="deleteBtn(item,index)">x</span> -->
              <a-icon class="delete-icon" type="close-circle" @click="deleteBtn(item, index)" />
            </div>
          </a-col>

          <a-col :span="3" v-if="contrastInputStatus" class="select-box">
            <a-select
              show-search
              :value="context2"
              :default-active-first-option="false"
              :show-arrow="false"
              :filter-option="false"
              :not-found-content="null"
              @focus="handleSearch"
              @search="handleSearch"
              @change="handleChange"
              @select="handleSelect"
              @inputKeydown.enter="() => { contrastInputStatus = false }"
            >
              <a-select-option v-for="d in keyword" :key="d.period_id">
                {{ d.name }}
              </a-select-option>
            </a-select>
            <a-icon class="select-del-icon" type="close-circle" @click="() => { contrastInputStatus = false }" />
          </a-col>
          <a-col :span="3">
            <div style="display: flex;">
              <a-button  @click="addContrast" style="margin-right: 10px;"> + 添加对比 </a-button>
              <a-button type="primary" @click="chaDate" icon="search">查询</a-button>
            </div>
          </a-col>
        </a-row>
      </a-card>
    </a-row>

    <a-row>
      <a-col :span="24" class="line-title" :style="{ marginLeft: '24px' }">
        <span v-for="(item, index) in schoolEmotionsTitle" :key="index">
          <span
            style="cursor: pointer;"
            :class="{ primaryColor: index === schoolEmotionsTitle.length - 1 && schoolEmotionsTitle.length > 1 }"
            @click="fallback(index)"
            >
              {{ item }}
          </span>
          <span v-if="schoolEmotionsTitle.length - 1 != index"> > </span>
        </span>
      </a-col>
      <a-col :span="24">
        <a-row>
          <a-col :span="17">
            <a-row>
              <a-col :span="24">
                <a-card class="leftCardBox" :loading="loading" :bordered="false" :style="{ marginBottom: '24px' }">
                  <div class="salesCard">
                    <LineChart :title="`${currentLineTitle}情绪变化趋势`" style="margin-bottom: 20px;" height="250px" :fields="moodField" :dataSource="schoolMood">
                      <template slot="titleExtra">
                        <a-button type="primary" class="add-btn" @click="addEventClick">添加事件</a-button>
                      </template>
                    </LineChart>
                  </div>
                </a-card>
              </a-col>
              <a-col :span="24">
                <a-card class="leftCardBox" :loading="loading" :bordered="false" :style="{ marginBottom: '24px' }">
                  <div class="salesCard">
                    <LineChart :title="`${currentLineTitle}情绪波动指数趋势`" style="margin-bottom: 20px;" height="250px" :fields="volatilityIndex" :dataSource="schoolMoodSwings"/>
                  </div>
                </a-card>
              </a-col>
              <a-col :span="24">
                <a-card class="leftCardBox" :loading="loading" :bordered="false" :style="{ marginBottom: '24px' }">
                  <div class="salesCard">
                    <a-row>
                      <a-col :span="12">
                        <LineChart title="学生活跃度对比" :grid="grid" style="margin-bottom: 20px;" height="250px" :fields="['学生活跃度']" :dataSource="studentActivity"/>
                      </a-col>
                      <a-col :span="12">
                        <LineChart title="家长关注度对比" :grid="grid" style="margin-bottom: 20px;" height="250px" :fields="['家长活跃度']" :dataSource="parentVisit"/>
                      </a-col>
                    </a-row>
                  </div>
                </a-card>
              </a-col>
<!--              <a-col :span="24">-->
<!--                <a-card class="leftCardBox" :loading="loading" :bordered="false" :style="{ marginBottom: '24px' }">-->
<!--                  <div class="salesCard">-->
<!--                    <a-row>-->
<!--                      <a-col :span="12">-->
<!--                        <LineChart title="性别愉悦指数对比" :grid="grid" style="margin-bottom: 20px;" height="250px" :fields="['男生', '女生']" :dataSource="sexData"/>-->
<!--                      </a-col>-->
<!--                      <a-col :span="12">-->
<!--                        <LineChart title="年龄愉悦指数对比" :grid="grid" style="margin-bottom: 20px;" height="250px" :fields="['10~12', '12~14', '14~16']" :dataSource="ageData"/>-->
<!--                      </a-col>-->
<!--                    </a-row>-->
<!--                  </div>-->
<!--                </a-card>-->
<!--              </a-col>-->
<!--              <a-col :span="24">-->
<!--                <a-card class="leftCardBox" :loading="loading" :bordered="false" :style="{ marginBottom: '24px' }">-->
<!--                  <div class="salesCard">-->
<!--                      <LineChart title="成绩" style="margin-bottom: 20px;" height="250px" :fields="['语文', '数学', '英语', '物理', '化学']" :dataSource="scoreData"/>-->
<!--                  </div>-->
<!--                </a-card>-->
<!--              </a-col>-->
<!--              <a-col :span="24">-->
<!--                <a-card class="leftCardBox" :loading="loading" :bordered="false" :style="{ marginBottom: '24px' }">-->
<!--                  <div class="salesCard">-->
<!--                      <LineChart title="其他成绩" style="margin-bottom: 20px;" height="250px" :fields="['体育', '美术']" :dataSource="otherScoreData"/>-->
<!--                  </div>-->
<!--                </a-card>-->
<!--              </a-col>-->
            </a-row>
          </a-col>
          <a-col :span="7">
            <a-row>
              <a-col :span="24">
                <a-card class="RightCardBox" :loading="loading" :bordered="false" :style="{ marginBottom: '24px' }">
                  <TableList
                    :title="classEmotions.title"
                    :columns="classEmotions.columns"
                    :tableData="classEmotions.tableData"
                    @addContrast="(record) => addContrastCell(2, record)"

                  />
                </a-card>
              </a-col>
              <a-col :span="24">
                <a-card class="RightCardBox" :loading="loading" :bordered="false" :style="{ marginBottom: '24px' }">
                  <TableList
                    :title="recentMoodLowList.title"
                    :columns="recentMoodLowList.columns"
                    :tableData="recentMoodLowList.tableData"
                  >
                    <template slot="recentMoodLow" slot-scope="{ record }">
                      <span style="color: #86a3e5; cursor: pointer;" @click="viewUnhappyStudent(record)">查看</span>
                    </template>
                  </TableList>
                </a-card>
              </a-col>
              <a-col :span="24">
                <a-card class="RightCardBox" :loading="loading" :bordered="false" :style="{ marginBottom: '24px' }">
                  <TableList
                    :title="mainCareList.title"
                    :columns="mainCareList.columns"
                    :tableData="mainCareList.tableData"
                  >
                    <template slot="emotionalTrends" slot-scope="slotProps">
                      <span style="color: #86a3e5; cursor: pointer;" @click="viewCareList(slotProps, 2)">查看</span>
                    </template>
                  </TableList>
                </a-card>
              </a-col>
              <a-col :span="24" v-if="currentLineTitle == '班级'">
                <a-card class="RightCardBox" :loading="loading" :bordered="false" :style="{ marginBottom: '24px' }">
                  <TableList
                    :title="parentFollowList.title"
                    :columns="parentFollowList.columns"
                    :tableData="parentFollowList.tableData"
                  >
                    <template slot="phoneEmail" slot-scope="{record}">
                      <div style="display: flex;color: #1783EC;text-align: center;font-weight: bold;cursor: pointer;">
                        <div style="flex: 1;" @click="getParentPhone(record)">手机</div>
                        <div style="flex: 1;" @click="getParentEmail(record)">邮箱</div>
                      </div>
                    </template>
                  </TableList>
                </a-card>
              </a-col>
            </a-row>
          </a-col>
        </a-row>
      </a-col>
    </a-row>
    <AddEventModal ref="addEventModal" @refresh="refreshMarked" />
    <ViewKeyPointModal ref="viewKeyPointModal" />
    <PhoneDetailModal ref="phoneDetailModal"/>
    <EmailDetailModal ref="emailDetailModal"/>
  </div>
</template>

<script>
import RankList from '@/components/chart/RankList'
import TableList from '@/components/chart/TableList'
import BarAndLine from '@/components/chart/BarAndLine'
import { getAction } from '@api/manage'
import SmoothLineChartMultid from '@/components/chart/SmoothLineChartMultid'
import LineChart from '@/components/echartZyz/components/LineChart'
import JSearchSelectTag from '@/components/dict/JSearchSelectTag'
import splitPane from 'vue-splitpane'
import moment from 'moment'
import { addLineCompare, deleteLineCompare, handleLineChartData, randomColor, saveFieldsArrKey } from '@/utils/util'
import AddEventModal from './components/AddEventModal'
import ViewKeyPointModal from './components/ViewKeyPointModal'
import CountAnimation from '@/components/CountAnimation'
import PhoneDetailModal from './components/campusPreview/PhoneDetailModal'
import EmailDetailModal from './components/campusPreview/EmailDetailModal'

export default {
  name: 'ClassWarnModel',
  components: {
    RankList,
    BarAndLine,
    SmoothLineChartMultid,
    JSearchSelectTag,
    splitPane,
    TableList,
    AddEventModal,
    ViewKeyPointModal,
    CountAnimation,
    PhoneDetailModal,
    EmailDetailModal,
    LineChart
  },
  data() {
    return {
      loading: false,
      context2: '',
      queryParam: {
        con: '',
      },
      //查询数据范围
      rangeDate: [],
      keyword: [],
      compareData: [],
      total: {
        studentCount: 0,
        teacherCount: 0,
        normalPeople: 0,
        needCarePeople: 0,
        carePeople: 0,
        warnCnt: 0,
        tutorCnt: 0,

        classWarn: 0,
        moodRecords:0,
        moodWarn:0,
      },
      schoolMood: [],
      loadingChart: false,
      loadingMoodChart: false,
      contrastInputStatus: false,
      gradeTrendsRanking: [],
      classTrendsRanking: [],
      careTrendsRanking: [],
      careAverage: {},
      studentActivity: [],
      parentVisit: [],
      schoolMoodSwings: [],

      scoreData: [
        {
          type: '2024-01-09',
          语文: 86,
          数学: 89,
          英语: 89,
          物理: 95,
          化学: 87,
        },
        {
          type: '2024-01-10',
          语文: 82,
          数学: 88,
          英语: 94,
          物理: 88,
          化学: 95,
        },
        {
          type: '2024-01-11',
          语文: 92,
          数学: 92,
          英语: 90,
          物理: 88,
          化学: 89,
        },
        {
          type: '2024-01-12',
          语文: 89,
          数学: 90,
          英语: 92,
          物理: 90,
          化学: 87,
        },
      ],
      otherScoreData: [
        {
          type: '2024-01-01',
          体育: 95,
          美术: 90,
        },
        {
          type: '2024-01-02',
          体育: 93,
          美术: 93,
        },
        {
          type: '2024-01-03',
          体育: 95,
          美术: 97,
        },
        {
          type: '2024-01-04',
          体育: 98,
          美术: 93,
        },
        {
          type: '2024-01-05',
          体育: 95,
          美术: 94,
        },
      ],
      sexData: [
        {
          type: '2024-01-01',
          男生: 22,
          女生: 32,
        },
        {
          type: '2024-01-02',
          男生: 33,
          女生: 27,
        },
        {
          type: '2024-01-03',
          男生: 34,
          女生: 33,
        },
        {
          type: '2024-01-04',
          男生: 25,
          女生: 30,
        },
        {
          type: '2024-01-05',
          男生: 29,
          女生: 30,
        },
      ],
      ageData: [
        {
          type: '2024-01-01',
          '10~12': 33,
          '12~14': 30,
          '14~16': 31,
        },
        {
          type: '2024-01-02',
          '10~12': 28,
          '12~14': 26,
          '14~16': 29,
        },
        {
          type: '2024-01-03',
          '10~12': 29,
          '12~14': 27,
          '14~16': 28,
        },
        {
          type: '2024-01-04',
          '10~12': 27,
          '12~14': 22,
          '14~16': 29,
        },
        {
          type: '2024-01-05',
          '10~12': 30,
          '12~14': 32,
          '14~16': 28,
        },
      ],
      schoolEmotionsTitle: ['年级情绪变化趋势'],
      moodField: ['愉悦指数', '关爱名单愉悦指数'],
      volatilityIndex: ['波动指数'],
      searchItem: [],
      searchItemColor: [],
      gradeEmotions: {
        title: '年级情绪趋势排名',
        columns: [
          {
            title: '排名',
            dataIndex: 'ranking',
            scopedSlots: { customRender: 'ranking' },
          },
          {
            title: '年级',
            dataIndex: 'grade',
          },
          {
            title: '愉悦指数',
            dataIndex: 'pleasureIndex',
            defaultSortOrder: 'descend',
            sorter: (a, b) => a.pleasureIndex - b.pleasureIndex,
          },
          {
            title: '操作',
            dataIndex: 'action',
            scopedSlots: { customRender: 'action' },
          },
        ],
        tableData: [],
      },
      parentFollowList: {
        title: '家长关注情况',
        columns: [
          {
            title: '关爱度',
            dataIndex: 'care_list',
            align: 'center',
            customRender: (_, record) => {
              return record.care_list ? <img style="width: 18px;height: 18px;" src={require('@/assets/love.png')}/> : ''
            },
          },
          {
            title: '姓名',
            dataIndex: 'name',
            align: 'center',
          },
          {
            title: '家长访问次数',
            dataIndex: 'cnt',
            align: 'center',
            customHeaderCell: () => {
              return {
                style: {
                  minWidth: '200px',
                },
              }
            },
            customCell: () => {
              return {
                style: {
                  minWidth: '200px',
                },
              }
            },
            sorter: (a, b) => a.cnt - b.cnt,
          },
          {
            title: '操作',
            dataIndex: 'phoneEmail',
            align: 'center',
            scopedSlots: { customRender: 'phoneEmail' },
          },
        ],
        tableData: [],
      },
      classEmotions: {
        title: '班级情绪趋势排名',
        columns: [
          {
            title: '排名',
            dataIndex: 'ranking',
            scopedSlots: { customRender: 'ranking' },
          },
          {
            title: '班级',
            dataIndex: 'class',
          },
          {
            title: '愉悦指数',
            dataIndex: 'pleasureIndex',
            sorter: (a, b) => a.pleasureIndex - b.pleasureIndex,
          },
          {
            title: '操作',
            dataIndex: 'action',
            scopedSlots: { customRender: 'action' },
          },
        ],
        tableData: [],
      },
      recentMoodLowList: {
        title: '近期不开心学生',
        columns: [
          {
            title: '排名',
            dataIndex: 'ranking',
            align: 'center',
            key: 'ranking',
            width: 60,
          },
          {
            title: '年级',
            dataIndex: 'name',
            customRender: (text) => {
              return <div style="min-width: 120px;">{text}</div>
            }
          },
          {
            title: '人数',
            align: 'center',
            dataIndex: 'pleasureIndex',
            sorter: (a, b) => a.pleasureIndex - b.pleasureIndex,
          },
          {
            title: '操作',
            dataIndex: 'recentMoodLow',
            align: 'center',
            scopedSlots: { customRender: 'recentMoodLow' },
          },
        ],
        tableData: [],
      },
      mainCareList: {
        title: '重点关爱名单',
        columns: [
          {
            title: '排名',
            dataIndex: 'ranking',
            key: 'ranking',
          },
          {
            title: '班级',
            dataIndex: 'student_class',
          },
          {
            title: '名字',
            dataIndex: 'name',
          },
          {
            title: '提醒次数',
            dataIndex: 'warn',
            sorter: (a, b) => a.warn - b.warn,
          },
          {
            title: '愉悦指数',
            dataIndex: 'pleasureIndex',
            sorter: (a, b) => a.pleasureIndex - b.pleasureIndex,
          },
          {
            title: '情绪趋势',
            dataIndex: 'emotionalTrends',
            scopedSlots: { customRender: 'emotionalTrends' },
          },
        ],
        tableData: [],
      },
      grid: { top: '10%', bottom: '25%', left: '12%', right: '12%' },
      tendencyType: {
          grade: {
            changeTrend: [],
            moodSwings: [],
            trendFields: [],
          },
          class: {
            changeTrend: [],
            moodSwings: [],
            trendFields: [],
          },
        },
    }
  },
  created() {
    this.rangeDate = [moment().subtract(14, 'days'), moment().subtract(1, 'days')]
    this.queryParam.beginDate = moment().subtract(14, 'days').format('YYYY-MM-DD')
    this.queryParam.endDate = moment().subtract(1, 'days').format('YYYY-MM-DD')
    this.loadData()
  },
  computed: {
    currentLineTitle() {
      const endTitle = this.schoolEmotionsTitle[this.schoolEmotionsTitle.length - 1]
      const currTitleType = endTitle.includes('年级') ? '年级' : '班级'
      return currTitleType
    }
  },
  methods: {
    filterLineField(obj, field) {
      const keys = Object.keys(obj)
      if (!keys.length) return []
      const filterKeys = keys.filter(item => !field.includes(item))
      return filterKeys
    },
    // 查询事件
     chaDate() {
      this.contrastInputStatus = false
      this.searchItem = []
      this.context2 = ''
      // console.log('查询参数：', this.queryParam)
      // 重新加载数据
       this.loadData()
    },
    // 添加对比
    addCompareData(params) {
      this.loadingChart = true
      getAction('/statistic/compareData', {...this.queryParam, ...params}).then((res) => {
        if (res.success) {
          this.compareData = res.result
          // this.schoolMood.push(this.compareData)
          const { lineData, filedList } = addLineCompare(this.schoolMood, this.moodField, this.compareData)
          this.schoolMood = lineData
          this.moodField =  filedList
        }
      }).finally(() => {
        this.loadingChart = false
      })
    },
    loadData() {
      getAction('/statistic/classTrendsRanking', this.queryParam).then((res) => {
        console.log(res)
        if (res.success) {
          const classData = res.result.map((item, index) => {
            return {
              ...item,
              ranking: index + 1,
              class: item.name,
              pleasureIndex: item.total,
            }
        })
        if (classData.length && !this.schoolMood.length && !this.schoolMoodSwings.length) {
            this.getGradeClassWarnNumTrend(2, classData[0])
            this.getVarianceUndulateTrend(2, classData[0])
          }
          this.$set(this.classEmotions, 'tableData', classData)
        }
      })
      getAction('/statistic/recentMoodLow', this.queryParam).then((res) => {
        console.log(res)
        if (res.success) {
          const classData = res.result.map((item, index) => {
            return {
              ...item,
              ranking: index + 1,
              name: item.grade,
              id: item.grade_id,
              warn: item.visitCnt,
              pleasureIndex: item.lowNumber,
            }
          })
          this.$set(this.recentMoodLowList, 'tableData', classData)
        }
      })
      getAction('/statistic/careTrendsRanking', this.queryParam).then((res) => {
        console.log(res)
        if (res.success) {
          this.careAverage = res.result.average
          const careData = res.result.ranking.map((item, index) => {
            return {
              ...item,
              ranking: index + 1,
              pleasureIndex: item.total,
              id: item.student_id,
            }
          })
          // console.log('重点关爱名单--', careData)
          this.$set(this.mainCareList, 'tableData', careData)
        }
      })
      //学生活跃情况
      getAction('/statistic/studentActivityTrend', this.queryParam).then((res) => {
        console.log('学生活跃情况：', res.result)
        if (res.success) {
          this.studentActivity = res.result.length ? res.result.map(item => ({
            type: item.type,
            '学生活跃度': item.activity
          })) : []
        }
      })
      //家长访问情况
      getAction('/statistic/parentVisitTrend', this.queryParam).then((res) => {
        if (res.success) {
          this.parentVisit = res.result.length ? res.result.map(item => ({
            type: item.type,
            '家长活跃度': item.visit
          })) : []
        }
      })
      // if(this.schoolMood.length) {
      //   this.getGradeClassWarnNumTrend(1, gradeData[0])
      //   this.getVarianceUndulateTrend(1, gradeData[0])
      // }
    },
    getVarianceUndulateTrend(type, record) {
      // console.log('type---', type);
      // console.log('record-----', record);
      this.loadingMoodChart = true
      let query = {}
      switch(type) {
        case 1:
          query = {...this.queryParam, grade_id: record && record.grade_id}
          break;
        case 2:
          query = {...this.queryParam, class_id: record && record.class_id}
          break;
      }
      // 校园情绪波动指数
      getAction('/statistic/varianceUndulateTrend', query).then((res) => {
        // console.log('校园情绪波动指数', res)
        if (res.success) {
          this.schoolMoodSwings = res.result
          switch(type) {
            case 1:
              this.$set(this.tendencyType.grade, 'moodSwings', res.result)
              break;
            case 2:
              this.$set(this.tendencyType.class, 'moodSwings', res.result)
          }
        }
      }).finally(() => {
        this.loadingMoodChart = false
      })
    },
    getGradeClassWarnNumTrend(type, record) {
      this.loadingChart = true
      let query = {}
      switch(type) {
        case 1:
          query = {...this.queryParam, gradeId:  record.grade_id, name: record.name}
          break;
        case 2:
          query = {...this.queryParam, classId: record.class_id, name: record.name}
          break;
      }
      getAction('/statistic/schoolMoodTrend', query).then(res => {
        if (res.success) {
          const { filedList, lineData } = handleLineChartData(res.result)
          this.schoolMood = lineData
          this.moodField =  filedList
          switch(type) {
            case 1:
              this.$set(this.tendencyType.grade, 'changeTrend', lineData)
              this.$set(this.tendencyType.grade, 'trendFields', filedList)
              break;
            case 2:
              this.$set(this.tendencyType.class, 'changeTrend', lineData)
              this.$set(this.tendencyType.class, 'trendFields', filedList)
              break;
          }
        }
      }).finally(() => {
        this.loadingChart = false
      })
    },
    //修改时间范围
    onRangeChange(dates, dateString) {
      this.rangeType = 'range'
      this.rangeDate = dates

      this.queryParam.beginDate = dateString[0]
      this.queryParam.endDate = dateString[1]
      this.moodField= ['愉悦指数', '关爱名单愉悦指数'],
      this.searchItem = []

      this.loadData()
    },
    handleSearch(value) {
      console.log('过滤条件：', value);
      this.queryParam.con = value || ''
      getAction('/statistic/getKeyword', this.queryParam).then((res) => {
        if (res.success) {
          this.keyword = res.result
        }
      })
    },
    handleChange(value) {
      this.context2 = value
      let index = this.keyword.findIndex((i) => i.period_id == value)
      let name = this.keyword[index].name
      this.queryParam.crux = name
      this.queryParam.id = value
    },
    handleSelect(value) {
      let currItem = this.keyword.find((i) => i.period_id == value)
      console.log('当前选择项：', currItem);


      // console.log(this.queryParam)
      if (value) {
        if (!this.searchItem.includes(this.queryParam.crux)) {
        this.searchItem.push(this.queryParam.crux)
        this.searchItemColor.push(randomColor())
      }
      this.context2 = ''
      this.addCompareData({dataType: currItem.dataType})
      }
      this.contrastInputStatus = false
    },
    getParentPay(record) {
      const params = { beginDate: this.queryParam.beginDate, endDate: this.queryParam.endDate, classId: record.class_id }
      getAction('/statistic/parentVisitList', params).then((res) => {
        console.log('res---',  res);
           if (res.success) {
               this.$set(this.parentFollowList, 'tableData', res.result)
           }
       })
    },
    deleteBtn(item) {
      const lineData = deleteLineCompare(this.schoolMood, item)
      const idx = this.moodField.indexOf(item)
      this.moodField.splice(idx, 1)
      this.schoolMood = lineData
      const idx_s = this.searchItem.indexOf(item)
      this.searchItem.splice(idx_s, 1)
      this.searchItemColor.splice(idx_s, 1)
    },
    addContrast() {
      this.contrastInputStatus = true
    },
    addContrastCell(type, record) {
      switch(type) {
        case 1:
          this.$set(this.queryParam, 'id', record.grade_id)
          break;
        case 2:
          this.$set(this.queryParam, 'id', record.class_id)
          break;
      }
      this.$set(this.queryParam, 'crux', record.name)
      if (!this.searchItem.includes(this.queryParam.crux)) {
        this.searchItem.push(this.queryParam.crux)
        this.searchItemColor.push(randomColor())
      }
      // this.chaDate()
      this.addCompareData({})
    },
    fallback(index) {
      // 删除数组index之后的元素
      this.schoolEmotionsTitle.splice(index + 1, this.schoolEmotionsTitle.length - index - 1)
      this.searchItem = []

      switch(this.currentLineTitle) {
        case '年级':
          this.moodField = this.tendencyType.grade.trendFields
          this.schoolMood = saveFieldsArrKey( this.tendencyType.grade.changeTrend, this.moodField)
          this.schoolMoodSwings = this.tendencyType.grade.moodSwings
          break;
        case '班级':
          this.moodField = this.tendencyType.class.trendFields
          this.schoolMood = saveFieldsArrKey( this.tendencyType.class.changeTrend, this.moodField)
          this.schoolMoodSwings = this.tendencyType.class.moodSwings
          break;
      }
      // console.log('当前计算的文本：', this.currentLineTitle);
      // console.log('当前数据：', this.schoolMood);


    },
    teacherRemindList(slotProps){
      const id = slotProps.record.id;
      const customText = slotProps.record.teacherName+"老师您好，您收到一条来自后台"+"的提醒消息，本周您还有"+slotProps.record.unDealWarnCnt+"条提醒未处理，请及时跟进处理。";

      const requestData = {
        teacherId: id,
        text: customText
      };

      //催办班主任提醒处理
      getAction('/aigoes/schoolClass/earlyWarning',requestData).then((res) => {
        console.log(res)
        if (res.success) {
          // this.$message.success('催办成功！');
          this.$notification["success"]({
            message: '通知',
            description:
              '已提醒班主任！',
          });
        }
      })
    },
    // 添加事件
    addEventClick() {
      this.$refs.addEventModal.show(this.schoolMood, this.moodField)
    },
    // 刷新标注
    refreshMarked(record) {
      const porintIndex = this.schoolMood.findIndex(item => item[record.filed + 'id'] == record.id && item[record.filed + 'incident'] == record.incident)
      if (porintIndex != -1) {
          const incident = record.filed + 'incident'
          this.$set(this.schoolMood[porintIndex], incident, 1)
          this.schoolMood = [...this.schoolMood]
          // console.log('刷新标注的索引：', porintIndex);
          console.log('刷新标注后的数据：', this.schoolMood);
      }

    },
    // 查看事件
    viewCareList(data, type) {
      this.$refs.viewKeyPointModal.show(data.record, type)
    },
    viewUnhappyStudent(record) {
      this.$emit('skipUnhappyStu', record)
    },
    cardDetail(key) {
        this.$emit('cardDetail', key)
    },
    // 获取家长手机号
    getParentPhone(record) {
      // console.log('家长信息：', record);
      this.$refs.phoneDetailModal.show(record)
    },
    getParentEmail(record) {
      // console.log('邮箱信息：');
      this.$refs.emailDetailModal.show(record)
    }
  },
}
</script>

<style lang="less" scoped>
.circle-cust {
  position: relative;
  top: 28px;
  left: -100%;
}
.extra-wrapper {
  line-height: 55px;
  padding-right: 24px;
  text-align: right;

  .extra-item {
    display: inline-block;
    margin-right: 24px;

    a {
      margin-left: 24px;
    }
  }
}

.primaryColor {
  color: #297EDE;
}

.row-box {
  display: flex !important;
  flex-wrap: wrap !important;
}

/* 首页访问量统计 */
.head-info {
  position: relative;
  text-align: left;
  padding: 0 32px 0 0;
  min-width: 125px;

  &.center {
    text-align: center;
    padding: 0 32px;
  }

  span {
    color: rgba(0, 0, 0, 0.45);
    display: inline-block;
    font-size: 0.95rem;
    line-height: 42px;
    margin-bottom: 4px;
  }
  p {
    line-height: 42px;
    margin: 0;
    a {
      font-weight: 600;
      font-size: 1rem;
    }
  }
}
.page-header-index-wide {
  min-height: 100vh !important;
  background-color: #ffffff !important;
}
.tag-col {
  animation: tagAppear 0.3s linear;
}
.select-box {
  position: relative;
  animation: tagAppear 0.3s linear;
}
@keyframes tagAppear {
  from {
    transform: translate(20px, -20px) scale(0.4);
    opacity: 0;
  }
  to {
    transform: translate(0, 0) scale(1);
    opacity: 1;
  }
}
.tag-item {
  width: 100% !important;
  box-sizing: border-box;
  position: relative;
  border: 1px solid #ccc;
  border-radius: 2px;
  height: 30px;
  line-height: 30px;
  padding-left: 5px;
  // 不换行
  .tag-name {
    display: inline-block;
    width: 100%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}
.delete-icon {
  cursor: pointer;
  background-color: #c8b9bc;
  color: #fff;
  border-radius: 50%;
  position: absolute;
  top: -10px;
  right: -6px;
}
.select-del-icon {
  cursor: pointer;
  background-color: #c8b9bc;
  color: #fff;
  border-radius: 50%;
  position: absolute;
  top: -1px;
  right: 3px;
}
.line-title {
  font-size: 17px;
  font-weight: 600;
  color: #262626;
  font-family: 'Arial', sans-serif;
}
.leftCardBox {
  border: 1px solid #e4e4e4;
  border-radius: 10px;
  margin: 10px;
  margin-left: 20px;
  ::v-deep {
    .ant-card-body {
      padding-bottom: 0px;
    }
  }
}
.RightCardBox {
  margin: 10px;
  border: 1px solid #e4e4e4;
  border-radius: 10px;
  ::v-deep {
    .ant-card-body {
      padding: 16px;
    }
  }
}
.head-card-box {
  min-height: 135px;
  color: #fff;
  border-radius: 15px;
  padding: 0px 20px;
  .card-title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 10px;
    font-size: 18px;
    font-weight: bold;
    .detail-icon {
        padding: 4px 16px;
        background: #fff;
        border-radius: 4px;
        cursor: pointer;
        font-size: 14px;
        color: #23CDAD;
    }
  }
}
.card-content {
  display: flex;
  justify-content: space-between;
  .card-item {
    // flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    .item-value {
      font-size: 28px;
      font-weight: bold;
      margin-bottom: 2px;
    }
    .item-desc {
      font-size: 14px;
    }
  }
}
.add-btn {
  background-color: #ffffff;
  color: #1890ff;
  border-color: #1890ff;
  text-shadow: none;
  box-shadow: none;
}
::v-deep {
  .ant-select {
    width: 100% !important;
  }
}
</style>

